import { PostHog } from 'posthog-js-lite'

import { PUBLIC_POSTHOG_HOST, PUBLIC_POSTHOG_KEY } from '$app/env/public'

export const detectDevice = (userAgent: string) => {
	if (/Windows Phone/i.test(userAgent) || /WPDesktop/.test(userAgent)) {
		return 'Windows Phone'
	} else if (/iPad/.test(userAgent)) {
		return 'iPad'
	} else if (/iPod/.test(userAgent)) {
		return 'iPod Touch'
	} else if (/iPhone/.test(userAgent)) {
		return 'iPhone'
	} else if (/(BlackBerry|PlayBook|BB10)/i.test(userAgent)) {
		return 'BlackBerry'
	} else if (/Android/.test(userAgent) && !/Mobile/.test(userAgent)) {
		return 'Android Tablet'
	} else if (/Android/.test(userAgent)) {
		return 'Android'
	} else {
		return ''
	}
}

export const detectDeviceType = (userAgent: string) => {
	const device = detectDevice(userAgent)

	if (device === 'iPad' || device === 'Android Tablet') {
		return 'Tablet'
	} else if (device) {
		return 'Mobile'
	} else {
		return 'Desktop'
	}
}

export const phg = new PostHog(PUBLIC_POSTHOG_KEY, {
	host: PUBLIC_POSTHOG_HOST,
	autocapture: false,
	disabled: import.meta.env.MODE === 'development',
})

export const hashToOption = (value: Nullable<string>, optionsCount: number) => {
	if (!value) return optionsCount

	let hash = 0

	for (const char of value) hash = (hash * 31 + char.charCodeAt(0)) | 0

	return (Math.abs(hash) % optionsCount) + 1
}
